var _style, _g, _g2, _g3, _polygon, _path, _path2, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSonidoOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 185.8 185.8",
    style: {
      enableBackground: "new 0 0 185.8 185.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9EACED;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 92.9,
    cy: 92.9,
    r: 92.9
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.8,148.1c-1.5,0-3.1-0.6-4.2-1.8L38.8,47.9c-2.3-2.3-2.3-6.1,0-8.5c2.3-2.3,6.1-2.3,8.5,0l99.8,98.5 c2.3,2.3,2.3,6.1,0,8.5C145.9,147.6,144.3,148.1,142.8,148.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.2,49.6L61.3,66h-20c-3.3,0-6,2.7-6,6v41.8c0,3.3,2.7,6,6,6h20l21.9,16.4c4,3,9.6,0.2,9.6-4.8v-77 C92.8,49.4,87.1,46.6,83.2,49.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.6,59.4c-2.7-2.7-7.2-2.7-9.9,0c-2.7,2.7-2.7,7.2,0,9.9c13,13,13,34.1,0,47.1c-2.7,2.7-2.7,7.2,0,9.9 c1.4,1.4,3.2,2,4.9,2s3.6-0.7,4.9-2.1C131.1,107.9,131.1,77.9,112.6,59.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.4,43.7c-2.7,2.7-2.7,7.2,0,9.9c10.5,10.5,16.3,24.4,16.3,39.3s-5.8,28.8-16.3,39.3 c-2.7,2.7-2.7,7.2,0,9.9c1.4,1.4,3.2,2.1,4.9,2.1c1.8,0,3.6-0.7,4.9-2c13.1-13.1,20.4-30.6,20.4-49.2s-7.2-36-20.4-49.2 C127.6,41,123.2,41,120.4,43.7z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "70.9,58.8 61.3,66 54,66 92.8,104.7 92.8,80.7 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.7,99.6c-1.2,5.8-3.9,11.3-8.2,15.8l9.8,9.8c4.2-4.3,7.4-9.3,9.5-14.5L111.7,99.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.5,118.4c-2.6,5-6,9.7-10.1,13.8c0,0-0.1,0.1-0.1,0.1l9.9,9.9c4.1-4.1,7.6-8.6,10.5-13.5L130.5,118.4z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.9,162.1c-1.5,0-3.1-0.6-4.2-1.8L28.3,54.7c-2.3-2.3-2.3-6.1,0-8.5c2.3-2.3,6.1-2.3,8.5,0l107.4,105.6 c2.3,2.3,2.3,6.1,0,8.5C142.9,161.5,141.4,162.1,139.9,162.1z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonidoOff);
export default __webpack_public_path__ + "static/media/SonidoOff.bc32f037962c20de383b0fb283b0459b.svg";
export { ForwardRef as ReactComponent };